<p class="pb-4">Dette kjøpet er regulert av kjøpsvilkårene nedenfor. Forbrukerkjøp reguleres hovedsakelig av avtaleloven,
  forbrukerkjøpsloven, markedsføringsloven, angrerettloven og e-handelsloven, og disse lovene gir forbrukeren
  ufravikelige rettigheter. Lovene er tilgjengelige på www.lovdata.no. Vilkårene skal ikke forstås som noen
  begrensning i de lovbestemte rettighetene, men beskriver partenes viktigste rettigheter og plikter for handelen.
  Vilkårene bygger på Forbrukertilsynets standard salgsbetingelser for forbrukerkjøp over internett.</p>

<ol class="list-decimal pl-6">
  <li>
    <span class="font-bold">Avtalen</span>
    <p>Avtalen består av bestillingen du gjør i appen, opplysningene som gis i bestillingsløsningen og disse
      vilkårene. Ved motstrid går ufravikelig lovgivning foran vilkårene.</p>
  </li>
  <li>
    <span class="font-bold">Partene</span>
    <p>Selger er {{ show(busName) }}, org.nr. {{ show(orgNumber) }}, {{ show(busAddress) }}, e-post {{ show(email) }},
      telefon {{ show(phone) }}, og betegnes i det følgende som selger. Kjøper er forbrukeren som foretar bestillingen.</p>
    <p>Bestillings- og betalingsløsningen leveres av Heynow AB NUF, org.nr. 938 097 046, norsk filial av Heynow AB
      (svensk org.nr. 559103-2189), www.heynow.ai, info&#64;heynow.ai. Heynow er ikke part i kjøpet.</p>
  </li>
  <li>
    <span class="font-bold">Pris</span>
    <p>Alle priser oppgis i norske kroner (NOK) inkludert merverdiavgift. Totalbeløpet du skal betale vises i appen
      før du bekrefter betalingen, og det tilkommer ingen gebyrer utover det som vises der.</p>
  </li>
  <li>
    <span class="font-bold">Avtaleinngåelse</span>
    <p>Avtalen er bindende for begge parter når betalingen er godkjent. Avtalen er likevel ikke bindende hvis det har
      forekommet skrive- eller tastefeil i tilbudet fra selger eller i bestillingen fra kjøper, og den andre parten
      innså eller burde ha innsett at det forelå en slik feil.</p>
  </li>
  <li>
    <span class="font-bold">Betaling</span>
    <p *ngIf="payment?.vipps">Du kan betale med Vipps. Beløpet reserveres når du godkjenner betalingen i Vipps-appen
      og trekkes umiddelbart etter.</p>
    <p *ngIf="payment?.card">Du kan betale med betalingskort (Visa og Mastercard), inkludert Apple Pay og Google Pay
      der det tilbys. Kortet belastes umiddelbart.</p>
    <p *ngIf="!payment?.vipps && !payment?.card">Du betaler med betalingsmåtene som tilbys i appen. Beløpet trekkes
      når betalingen godkjennes.</p>
    <p>Betalingen håndteres av betalingsleverandøren sammen med dens samarbeidspartnere. Selger lagrer ikke
      kortopplysninger.</p>
  </li>
  <li>
    <span class="font-bold">Levering</span>
    <p>Varene serveres eller hentes på serveringsstedet. Det tilbys ingen frakt eller hjemlevering gjennom appen.</p>
  </li>
  <li>
    <span class="font-bold">Angrerett</span>
    <p>Mat og drikke som tilberedes for servering er unntatt fra angreretten etter angrerettloven. Oppdager du feil i
      bestillingen, si fra til personalet med en gang, så retter de det.</p>
  </li>
  <li>
    <span class="font-bold">Mangel ved varen, reklamasjon og refusjon</span>
    <p>Hvis det foreligger en mangel ved varen, må du innen rimelig tid etter at den ble oppdaget gi selger melding om
      at du vil påberope deg mangelen. Dine rettigheter følger av forbrukerkjøpsloven. Reklamasjon rettes i første
      omgang til personalet på serveringsstedet.</p>
    <p>Har du blitt belastet dobbelt eller betalt feil pris, kontakt personalet eller Heynow via kontaktopplysningene i
      punkt 10. Refusjon skjer til samme betalingsmiddel som ble brukt ved kjøpet.</p>
  </li>
  <li>
    <span class="font-bold">Personopplysninger</span>
    <p>For å kunne motta, håndtere og levere bestillingen din behandler Heynow AB personopplysninger. Behandlingen
      skjer i samsvar med gjeldende personvernlovgivning. Les mer i Vedlegg 1, Behandling av personopplysninger.</p>
  </li>
  <li>
    <span class="font-bold">Kontakt og kundeservice</span>
    <ul class="list-disc pl-6">
      <li>E-post: support&#64;heynow.ai</li>
      <li>Telefon: +46 10 214 60 77</li>
    </ul>
  </li>
  <li>
    <span class="font-bold">Informasjonskapsler (cookies)</span>
    <p>En informasjonskapsel er en liten tekstfil som nettstedet lagrer i nettleseren din, enten bare for økten eller
      som en fil. Appen bruker informasjonskapsler og tilsvarende lagring for å huske for eksempel innlogging og
      bestillingen din. Er nettleseren innstilt på å avvise dem, kan du ikke bestille i appen. Vi bruker ikke
      informasjonskapsler til å lagre personlig informasjon om deg.</p>
  </li>
  <li>
    <span class="font-bold">Force majeure</span>
    <p>Krig, omfattende arbeidskonflikt, blokade, brann, miljøkatastrofe, alvorlig smittespredning eller andre forhold
      utenfor en parts kontroll som hindrer parten i å oppfylle sine forpliktelser, fritar parten fra dem så lenge
      virksomheten ikke kan drives under disse forholdene. Den andre parten skal straks underrettes om slike forhold.</p>
  </li>
  <li>
    <span class="font-bold">Endring av vilkårene</span>
    <p>Etter at kjøpet er gjennomført kan selger ikke endre vilkårene for det aktuelle kjøpet uten at annet er avtalt.</p>
  </li>
  <li>
    <span class="font-bold">Klager</span>
    <p>Klager rettes i første omgang til personalet på serveringsstedet, alternativt via kontaktopplysningene i
      punkt 10.</p>
  </li>
  <li>
    <span class="font-bold">Konfliktløsning og lovvalg</span>
    <p>Partene skal forsøke å løse eventuelle tvister i minnelighet. Som forbruker kan du kontakte Forbrukertilsynet
      for mekling, se www.forbrukertilsynet.no. Norsk rett gjelder for kjøpet, og tvister som ikke løses i minnelighet
      avgjøres av norske domstoler.</p>
  </li>
</ol>

<span class="pt-4 font-semibold">Vedlegg 1, Behandling av personopplysninger</span>
<p class="pt-2">Heynow AB, svensk org.nr. 559103-2189, behandler personopplysninger i forbindelse med handel gjennom Heynows
  bestillingssystem og er behandlingsansvarlig for behandlingen. Personopplysningene behandles for at Heynow AB skal
  kunne levere sine tjenester, hovedsakelig for følgende formål («Formålene»):</p>
<ul class="list-disc pl-6">
  <li>For å opprette og vedlikeholde din personlige konto.</li>
  <li>For å motta og behandle dine bestillinger og betalinger.</li>
  <li>For å håndtere eventuelle refusjoner.</li>
  <li>For å besvare dine spørsmål og informere deg om nye eller endrede tjenester.</li>
  <li>For å sende markedsføring som nyhetsbrev og kataloger.</li>
  <li>For å sende deg undersøkelser som gir deg mulighet til å påvirke Heynow ABs tilbud og tjenester.</li>
</ul>

<p>Opplysningene som behandles er de du selv oppgir, for eksempel når du legger inn bestillinger eller kontakter
  kundeservice, slik som kontaktinformasjon, leveringsadresse og bestilte varer («Personopplysningene»).
  Personopplysningene er nødvendige for at Heynow AB skal kunne oppnå Formålene. Enkelte opplysninger kan også hentes
  fra offentlige registre eller andre allment tilgjengelige kilder. Det viktigste rettslige grunnlaget for
  behandlingen er at den er nødvendig for at Heynow AB skal kunne oppfylle sine forpliktelser overfor kundene. Enkelte
  behandlinger bygger også på Heynow ABs berettigede interesse i å drive virksomheten effektivt og sikkert, og på
  Heynow ABs plikt til å følge rettslige forpliktelser. Personopplysningene gjøres ikke tilgjengelige for tredjeparter
  utover det som er nødvendig for å fullføre bestillingen. Overføres opplysninger til et land utenfor EU/EØS som
  EU-kommisjonen ikke anser å sikre et tilstrekkelig beskyttelsesnivå, skjer overføringen med grunnlag i kommisjonens
  standardavtaleklausuler, jf. artikkel 45–46 i forordning 2016/679 («GDPR»), tilgjengelige på
  http://ec.europa.eu/justice/data-protection/international-transfers/transfer/. Behandlingen pågår så lenge det er
  nødvendig for å oppfylle Formålene eller så lenge Heynow AB er forpliktet til det. Deretter slettes
  Personopplysningene. Har du spørsmål om behandlingen, kontakt Heynow AB på info&#64;heynow.ai. Som registrert har du
  rettigheter etter GDPR. Merk at rettighetene ikke er absolutte, og at en henvendelse derfor ikke nødvendigvis fører
  til et tiltak. Dine rettigheter etter GDPR omfatter følgende:</p>
<ul class="list-disc pl-6">
  <li>Rett til innsyn – Etter artikkel 15 GDPR har du rett til innsyn i Personopplysningene og til å bli informert om
    behandlingen. Den informasjonen finner du i dette dokumentet.
  </li>
  <li>Rett til retting – Etter artikkel 16 GDPR har du rett til uten ugrunnet opphold å få rettet uriktige
    personopplysninger om deg. Med hensyn til formålet med behandlingen har du også rett til å supplere ufullstendige
    personopplysninger.
  </li>
  <li>Rett til sletting («retten til å bli glemt») – Under visse omstendigheter har du etter artikkel 17 GDPR rett til
    å få Personopplysningene slettet.
  </li>
  <li>Rett til begrensning av behandlingen – Under visse omstendigheter har du etter artikkel 18 GDPR rett til å kreve
    at behandlingen av Personopplysningene begrenses.
  </li>
  <li>Rett til dataportabilitet – Etter artikkel 20 GDPR har du rett til å få utlevert Personopplysningene i et
    strukturert, alminnelig anvendt og maskinlesbart format, og til å overføre dem til en annen behandlingsansvarlig.
  </li>
  <li>Rett til å protestere – Etter artikkel 21 GDPR har du rett til å protestere mot visse former for behandling av
    Personopplysningene, for eksempel behandling som bygger på Heynow ABs berettigede interesser. Du har også rett
    til å klage til Datatilsynet, www.datatilsynet.no.
  </li>
</ul>
